// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hXXX","right":"styles_right__2MZkR"};